export default __webpack_public_path__ + "static/media/comfy about.80aa3af8.png";